import { useQuery } from "@tanstack/react-query";
import { notificationService } from "../services/notification.service";
import type { NotificationListParams } from "../types";

export const notificationKeys = {
	all: ["notifications"] as const,
	lists: () => [...notificationKeys.all, "list"] as const,
	list: (params?: NotificationListParams) => [...notificationKeys.lists(), params] as const,
};

export function useNotificationList(params?: NotificationListParams) {
	return useQuery({
		queryKey: notificationKeys.list(params),
		queryFn: () => notificationService.list(params),
		refetchInterval: 30_000,
	});
}
